// Redux Toolkit
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Master Store
import { RootState } from "../MasterStore";
// Actions
import { GetAllCategoriesAction, GetDropDownCategoriesAction } from '../Actions/CategoryAction';

// Interface
interface ICategories {
    loading?: boolean;
    categories?: any;
    category?: any;
    categoryDropDown?: any;
    error?: any;
}

// Initial State
const initialState: ICategories = {
    loading: false,
    categories: [],
    category: {},
    categoryDropDown: [],
    error: ''
}

// Get All Categories
export const GetAllCategories = createAsyncThunk(
    'categories',
    async () => {
        return await GetAllCategoriesAction();
    }
)

export const GetDropDownCategories = createAsyncThunk(
    'DropDownCategories',
    async () => {
        return await GetDropDownCategoriesAction();
    }
)

const CategorySlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {},
    extraReducers: ( Builder) => {

        // Get All Categories
        Builder.addCase( GetAllCategories.pending, (State) => {
            State.loading = true;
        })
        Builder.addCase( GetAllCategories.fulfilled, (State, Action) => {
            State.loading = false;
            State.categories = Action.payload.DATA.CATEGORY;
            State.error = '';
        })
        Builder.addCase( GetAllCategories.rejected ,(State, Action) => {
            State.loading = false;
            State.categories = [];
            State.error = Action.error?.message;
        })

        Builder.addCase( GetDropDownCategories.pending, (State) => {
            State.loading = true;
        })
        Builder.addCase( GetDropDownCategories.fulfilled, (State, Action) => {
            State.loading = false;
            State.categoryDropDown = Action.payload.DATA.CATEGORY;
            State.error = '';
        })
        Builder.addCase( GetDropDownCategories.rejected ,(State, Action) => {
            State.loading = false;
            State.categoryDropDown = [];
            State.error = Action.error?.message;
        })
    },
});

export const SelectCategories = ( State: RootState ) => State.Category;
export default CategorySlice.reducer;